/**
 * RouteScrollReset — scroll the window back to the top on every route
 * change.  React Router does NOT auto-reset scroll by default, which is
 * why navigating from the bottom of one page (e.g. landing footer) to
 * another route can leave the user appearing stuck at the bottom.
 *
 * Mount once near the top of the Router tree (after BrowserRouter).
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function RouteScrollReset() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If the URL has a hash (#how), the browser/anchor navigation will
    // handle the scroll itself — don't override it.
    if (hash) return;
    // Use 'instant' to avoid jarring smooth-scroll on top-level nav.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
